import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, StyleSheet, Text, TextInput, TouchableOpacity, View, Image } from 'react-native'
import { FREQUENCY_TYPE, STATUS_MODERATION, STATUS_PERIOD } from './constants/constants.stores'
import { Feather, Ionicons } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './CreateScheduleWeekStyles'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'
import { DistributorCardStatustag } from './CreateSchedule'
import { ScheduleCalendar, SelectedDistributorCard } from './CreateScheduleWeek'
import { formatearFechaArgentina } from '../customUtils/AppConstants'
import { Distributor, Period, Activity, Week, Day } from './models/CreateScheduleModel'
const { width } = Dimensions.get('window')

export const CreateScheduleMonth = ({
    period,
    updatePeriod,
    isModerator,
    indexWeek,
    indexDay,
    setWeek,
    setIndexDay,
    lockExecutive,
    monthly_distributor_activities,
    monthly_activities,
    updateMonthlyDistributorActivities,
    updateMonthlyActivities,
}: {
    period: Period
    updatePeriod: (period: Period) => void
    isModerator: boolean
    indexWeek: number
    indexDay: number
    setWeek: (index: number) => void
    setIndexDay: (index: number) => void
    lockExecutive: boolean
    monthly_distributor_activities: Activity[]
    monthly_activities: Activity[]
    updateMonthlyDistributorActivities: (activities: Activity[]) => void
    updateMonthlyActivities: (activities: Activity[]) => void
}) => {
    const weeks = period.weeks ?? []

    if (weeks.length === 0) {
        return (
            <View style={styles.containerNoSchedule}>
                <Image style={styles.imageNoSchedule} source={require('../../../assets/noScheduleWeek.png')} />
                <Text style={styles.titleNoSchedule}>Ha ocurrido un error al cargar los datos de la semana</Text>
                <Text style={styles.descriptionNoSchedule}>Vuelve a intentarlo más tarde</Text>
            </View>
        )
    }

    let defaultDistributor = { _id: '-1' }

    let selectedDay = weeks[indexWeek].days[indexDay]
    let selectedDate = new Date(selectedDay.date).toLocaleDateString('es-ES', {
        timeZone: 'UTC',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })

    const fechaActual = new Date()
    // const today = new Date('2024-10-05T12:56:46.950Z')
    const fechaArgentina = new Date(fechaActual.setHours(fechaActual.getHours() - 3))

    // Divide la fecha en partes
    const [diaMes, mes, año] = selectedDate.split(' de ') || [] // ["lunes, 21", "octubre 2024"]

    // Asegúrate de que diaMes tenga el formato correcto
    const diaSemana = diaMes?.split(', ')[0]?.trim() || '' // "lunes"
    const numeroDia = diaMes?.split(', ')[1]?.trim() || '' // "21"

    // Capitaliza la primera letra del día
    const primeraParte = `${diaSemana.charAt(0).toUpperCase()}${diaSemana.slice(1)} ${numeroDia} `

    // Mantén la segunda parte en minúsculas
    const segundaParte = `de ${mes.toLowerCase()} ${año.toLowerCase()}`

    let distributors = period.distributors ?? []
    let oldDist = period.weeks[indexWeek].days[indexDay].distributor
    const [selectedDistributor, setSelectedDistributor] = useState<Distributor>(oldDist ?? defaultDistributor)
    let dropDownOptions = distributors.filter((d) => selectedDistributor && selectedDistributor._id != d._id).map((d) => d)
    const [openPicker, setOpenPicker] = useState(false)

    const setDistributor = (distributor: Distributor) => {
        let newPeriod = { ...period }
        period.weeks[indexWeek].days[indexDay].distributor = distributor
        if (!distributor) {
            newPeriod.weeks[indexWeek].days[indexDay].monthly_distributor_activities = []
            period.weeks[indexWeek].days[indexDay].status = 3
            // verifico si tengo otras actividades
            if (period.weeks[indexWeek].days[indexDay].monthly_activities && period.weeks[indexWeek].days[indexDay].monthly_activities.length > 0) {
                // verifico si tengo alguna actividad con form_id
                if (period.weeks[indexWeek].days[indexDay].monthly_activities.some((a) => a.form_id)) {
                    period.weeks[indexWeek].days[indexDay].status = 0
                }
            }
        } else {
            period.weeks[indexWeek].days[indexDay].status = 0
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])
        updatePeriod(newPeriod)
        setOpenPicker(false)
    }
    const setDistributorActivity = (activity: Activity, add: boolean) => {
        let newPeriod = { ...period }
        if (add) {
            period.weeks[indexWeek].days[indexDay].monthly_distributor_activities.push(activity)
        } else {
            period.weeks[indexWeek].days[indexDay].monthly_distributor_activities = period.weeks[indexWeek].days[
                indexDay
            ].monthly_distributor_activities.filter((a) => a._id != activity._id)
        }

        if (activity.frequency) {
            let newActs = [...monthly_distributor_activities]
            let index = newActs.findIndex((a) => a._id == activity._id)
            if (newActs[index].count === null) {
                newActs[index].count = add ? 1 : 0
            } else {
                newActs[index].count = add ? (newActs[index].count || 0) + 1 : (newActs[index].count || 0) - 1
            }
            let related: Array<{ _id: string; status: number }> = newActs[index].related_distributors ?? []

            if (add) {
                console.log('Add')
                let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
                if (index2 != -1) {
                    // Si el distribuidor ya está en la lista, actualizar el status a -1
                    related[index2].status = 1
                } else {
                    let l = { _id: selectedDay.distributor?._id, status: 1 }
                    related = [...related, l]
                }
            } else {
                console.log('quit')
                let index2 = related.findIndex((d) => d._id == selectedDay.distributor?._id)
                if (index2 != -1) {
                    related = related.filter((d, i) => i != index2)
                }
            }
            newActs[index].related_distributors = related
            updateMonthlyDistributorActivities(newActs)
        }

        if (activity.vacation != undefined && activity.vacation) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].monthly_distributor_activities = []
        } else {
            period.weeks[indexWeek].days[indexDay].status = 0
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])
        updatePeriod(newPeriod)
        setOpenPicker(false)
    }

    useEffect(() => {
        setOpenMonthlyActivities(false)
        setOpenMonthlyDistActivities(false)
        setOpenPicker(false) // Cierro modales si cambio dia o semana
    }, [indexWeek, indexDay])

    const [openMonthlyDistActivities, setOpenMonthlyDistActivities] = useState(false)
    const getUseCounter = (act: Activity, id: string) => {
        let i = 0
        act.related_distributors?.forEach((d) => {
            if (d._id === id && d.status != -1) {
                i++
            }
        })
        return i
    }
    const getFilteredDistributorActivities = () => {
        let activities = []
        activities = monthly_distributor_activities
            .filter(
                (activity: Activity) =>
                    selectedDay.monthly_distributor_activities &&
                    !selectedDay.monthly_distributor_activities.some((a) => a._id === activity._id) &&
                    activity.days?.includes(selectedDay.day) &&
                    !(
                        activity.frequency === 'month' &&
                        activity.related_distributors &&
                        activity.related_distributors.some((distributor) => distributor._id === oldDist?._id)
                    ) &&
                    !(activity.frequency === 'fortnight' && activity.related_distributors && getUseCounter(activity, oldDist?._id) > 2),
            )
            .map((activity: Activity) => {
                let maxUses = null

                switch (activity.frequency) {
                    case FREQUENCY_TYPE.MONTH:
                        maxUses = 1
                        break
                    case FREQUENCY_TYPE.FORTNIGHT:
                        maxUses = 2
                        break
                    case FREQUENCY_TYPE.WEEKLY:
                        maxUses = 4
                        break
                    default:
                        maxUses = null
                }

                const currentUses = getUseCounter(activity, oldDist?._id)

                return {
                    ...activity,
                    availability: maxUses ? ` - ${currentUses}/${maxUses}` : '',
                }
            })
        return activities
    }
    let filterMonthlyDistActs: Activity[] = getFilteredDistributorActivities()

    const [openMonthlyActivities, setOpenMonthlyActivities] = useState(false)
    const getFilteredActivities = () => {
        let activities = []
        activities = monthly_activities
            .filter(
                (activity: Activity) =>
                    selectedDay.monthly_activities &&
                    !selectedDay.monthly_activities.some((a) => a._id === activity._id) &&
                    activity.days?.includes(selectedDay.day) &&
                    !(activity.frequency === 'month' && activity.count === 1) &&
                    !(activity.frequency === 'fortnight' && activity.count === 2),
            )
            .map((activity: Activity) => {
                let maxUses = null

                switch (activity.frequency) {
                    case FREQUENCY_TYPE.MONTH:
                        maxUses = 1
                        break
                    case FREQUENCY_TYPE.FORTNIGHT:
                        maxUses = 2
                        break
                    case FREQUENCY_TYPE.WEEKLY:
                        maxUses = 4
                        break
                    default:
                        maxUses = null
                }

                return {
                    ...activity,
                    availability: maxUses ? ` - ${activity.count || 0}/${maxUses}` : '',
                }
            })
        return activities
    }
    let filterMonthlyActs: Activity[] = getFilteredActivities()

    const setOtherActivity = (activity: Activity, add: boolean) => {
        let newPeriod = { ...period }
        if (add) {
            period.weeks[indexWeek].days[indexDay].monthly_activities.push(activity)
        } else {
            period.weeks[indexWeek].days[indexDay].monthly_activities = period.weeks[indexWeek].days[indexDay].monthly_activities.filter(
                (a) => a._id != activity._id,
            )

            if (period.weeks[indexWeek].days[indexDay].distributor == null) {
                period.weeks[indexWeek].days[indexDay].status = 3
                if (activity && activity.form_id) {
                    period.weeks[indexWeek].days[indexDay].status = 3
                } else {
                    period.weeks[indexWeek].days[indexDay].status = 3
                    // valido que no tenga distribuidor y que no tenga otras actividades con form id
                    if (
                        period.weeks[indexWeek].days[indexDay].distributor == null &&
                        period.weeks[indexWeek].days[indexDay].monthly_activities &&
                        period.weeks[indexWeek].days[indexDay].monthly_activities.length > 0
                    ) {
                        // verifico si tengo alguna actividad con form_id
                        if (period.weeks[indexWeek].days[indexDay].monthly_activities.some((a) => a.form_id)) {
                            period.weeks[indexWeek].days[indexDay].status = 0 // si tengo alguna actividad con form_id paso a 0
                        }
                    }
                }
            }
        }
        if (activity.frequency) {
            let newActs = [...monthly_activities]
            let index = newActs.findIndex((a) => a._id == activity._id)
            if (newActs[index].count === null) {
                newActs[index].count = add ? 1 : 0
            } else {
                newActs[index].count = add ? (newActs[index].count || 0) + 1 : (newActs[index].count || 0) - 1
            }
            updateMonthlyActivities(newActs)
        }

        if (activity.vacation != undefined && activity.vacation && add) {
            period.weeks[indexWeek].days[indexDay].status = 10
            period.weeks[indexWeek].days[indexDay].monthly_activities = []
            period.weeks[indexWeek].days[indexDay].monthly_activities.push(activity)
        } else {
            if (activity && activity.form_id && add) {
                period.weeks[indexWeek].days[indexDay].status = 0
            } else {
                period.weeks[indexWeek].days[indexDay].status = 3
            }
        }
        period.weeks[indexWeek].days[indexDay].status = getDayStatus(period.weeks[indexWeek].days[indexDay])
        updatePeriod(newPeriod)
        //setOpenOtherActivities(false)
    }
    const validateBloqued = (week: Week) => {
        let isBloqued = false

        if (week.days[indexDay].status == STATUS_PERIOD.PERIOD_APROBB) {
            isBloqued = true
        }
        return isBloqued
    }
    let isBloqued = validateBloqued(weeks[indexWeek])
    const getFreqLabel = (freq: string) => {
        let label = ''
        switch (freq) {
            case 'month':
                label = 'M'
                break
            case 'fortnight':
                label = 'Q'
                break
            case 'weekly':
                label = 'S'
                break
            case 'day':
                label = 'D'
                break
            default:
                label = 'D'
        }
        return label
    }

    const getDayStatus = (day: Day) => {
        let status = 3
        let isVacation = day.monthly_activities.some((a) => a.vacation == true)
        if (isVacation) {
            status = 10
        } else {
            if (day.day != 5) {
                //Dia de semana // && day.monthly_distributor_activities.length > 0
                if (day.distributor != null) {
                    status = 0
                } else {
                    if (day.monthly_activities.length > 0) {
                        let formId = day.monthly_activities.some((a) => a.form_id && a.status != -1)
                        if (formId) {
                            status = 0
                        } else {
                            status = 3
                        }
                    } else {
                        status = 3
                    }
                }
            } else {
                //Sabado
                if (day.monthly_activities.length > 0) {
                    //Tiene actividades
                    status = 0
                } else {
                    //No tiene actividades
                    status = 3
                }
            }
        }
        console.log('retorno esto', status)
        return status
    }

    return (
        <View style={styles.container}>
            <ScheduleCalendar
                week={weeks[indexWeek]}
                changeWeek={setWeek}
                currendDayIndex={indexDay}
                currendWeekIndex={indexWeek}
                changeDay={setIndexDay}
                isModerator={isModerator}
                periodStatus={period.status}
                period={period}
            />
            <View style={[styles.containerRow, styles.marginHorizontal]}>
                <Text style={[styles.date, { fontWeight: 'bold' }]}>{primeraParte}</Text>
                <Text style={[styles.date]}>{segundaParte.toLowerCase()}</Text>
            </View>
            {selectedDay.day != 5 && <View style={styles.spacer2}></View>}
            {selectedDay.status != 10 && (
                <View style={{ opacity: isBloqued || lockExecutive ? 0.7 : 1, pointerEvents: isBloqued || lockExecutive ? 'none' : null }}>
                    {distributors.length > 0 && selectedDay.day != 5 && selectedDay.status != STATUS_PERIOD.VACATION && (
                        <View>
                            <Text style={styles.section}>Planifica tu día: </Text>
                            <View style={styles.spacerMin}></View>
                            <Text style={styles.subSection}>
                                Una vez que selecciones al distribuidor, se habilitarán automáticamente las actividades correspondientes al mes que
                                están relacionadas con él
                            </Text>
                            <TouchableOpacity style={[styles.input, { marginHorizontal: 12 }]} onPress={() => setOpenPicker(!openPicker)}>
                                <Text style={styles.subtitle}>Elegir distribuidor</Text>
                                <View style={styles.containerRow}>
                                    <Feather name={openPicker ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                                </View>
                            </TouchableOpacity>

                            {openPicker && (
                                <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                    {dropDownOptions.length > 0 && (
                                        <ScrollView>
                                            <View>
                                                {dropDownOptions.map((distributor) => (
                                                    <TouchableOpacity
                                                        key={distributor._id}
                                                        style={{ marginVertical: 8 }}
                                                        onPress={() => setDistributor(distributor)}
                                                    >
                                                        <Text style={styles.title}>{distributor.name}</Text>
                                                        <Text style={styles.subtitle}>{distributor.address}</Text>
                                                    </TouchableOpacity>
                                                ))}
                                            </View>
                                        </ScrollView>
                                    )}
                                    <View style={styles.spacer2}></View>
                                </View>
                            )}
                        </View>
                    )}

                    {oldDist && (
                        <SelectedDistributorCard
                            key={indexWeek + indexDay}
                            distributor={oldDist}
                            deleteDistributor={() => setDistributor(null)}
                            activities={[]}
                            setActivity={(a, b) => {}}
                            selectedAct={selectedDay.activities}
                            canDelete={true}
                        />
                    )}
                </View>
            )}
            <View style={{ opacity: isBloqued || lockExecutive ? 0.7 : 1, pointerEvents: isBloqued || lockExecutive ? 'none' : null }}>
                {oldDist && selectedDay.day != 5 && selectedDay.status != 10 && (
                    <>
                        <TouchableOpacity
                            style={[styles.input, { marginTop: 0, marginHorizontal: 12 }]}
                            onPress={() => setOpenMonthlyDistActivities(!openMonthlyDistActivities)}
                        >
                            <Text style={[styles.subtitle, { flex: 16 }]}>Elegir actividad en distribuidor</Text>
                            <View style={[styles.containerRow, { flex: 1 }]}>
                                <Feather
                                    name={openMonthlyDistActivities ? 'chevron-up' : 'chevron-down'}
                                    size={22}
                                    color={theme.colors.colorPrimary}
                                />
                            </View>
                        </TouchableOpacity>

                        {openMonthlyDistActivities && (
                            <View>
                                {filterMonthlyDistActs.length > 0 && (
                                    <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                        {filterMonthlyDistActs.map((act) => (
                                            <TouchableOpacity
                                                key={act._id}
                                                style={{ marginVertical: 8 }}
                                                onPress={() => {
                                                    setDistributorActivity(act, true)
                                                    setOpenMonthlyDistActivities(false)
                                                }}
                                            >
                                                <Text style={styles.subtitle}>
                                                    {act.title}
                                                    {act.availability}
                                                </Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                        )}
                    </>
                )}

                {selectedDay.monthly_distributor_activities.length > 0 && selectedDay.status != 10 && (
                    <>
                        {weeks[indexWeek].days[indexDay].monthly_distributor_activities.map((activity) => (
                            <View
                                key={activity._id}
                                style={[
                                    styles.containerRow,
                                    styles.optionSelected,
                                    { flex: 1, marginHorizontal: 12, justifyContent: 'space-between', marginTop: 8 },
                                ]}
                            >
                                <View style={[styles.containerRow, { flex: 9 }]}>
                                    <Text style={[styles.option, { flex: 2 }]}>{activity.title}</Text>
                                </View>
                                <View style={[styles.label, { flex: 1, marginRight: 12 }]}>
                                    <Ionicons name={'calendar'} size={12} color={'white'} style={styles.paddingRight} />
                                    <Text style={styles.frequency}>{getFreqLabel(activity.frequency)}</Text>
                                </View>
                                <TouchableOpacity style={styles.marginRight} onPress={() => setDistributorActivity(activity, false)}>
                                    <Ionicons name={'trash-outline'} size={24} color={theme.colors.error} />
                                </TouchableOpacity>
                            </View>
                        ))}
                    </>
                )}

                {selectedDay.day != 5 && <View style={styles.spacer1}></View>}
                {selectedDay.day != 5 && <View style={styles.divider}></View>}
                <View style={styles.spacer1}></View>
                <Text style={styles.section}>Planifica otras actividades:</Text>
                <View style={styles.spacerMin}></View>
                <Text style={styles.subSection}>Selecciona las actividades no relacionadas con el distribuidor</Text>
                <TouchableOpacity
                    style={[styles.input, { marginHorizontal: 12 }]}
                    onPress={() => setOpenMonthlyActivities(!openMonthlyActivities)}
                    disabled={selectedDay.status == STATUS_PERIOD.VACATION}
                >
                    <Text style={styles.subtitle}>Elegir otras actividades</Text>
                    <View style={styles.containerRow}>
                        <Feather name={openMonthlyActivities ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                    </View>
                </TouchableOpacity>
                {openMonthlyActivities && (
                    <View>
                        {filterMonthlyActs.length > 0 && (
                            <View style={[styles.inputDropdownMenuSubsection, styles.marginHorizontal]}>
                                {filterMonthlyActs.map((act) => (
                                    <TouchableOpacity
                                        key={act._id}
                                        style={{ marginVertical: 8 }}
                                        onPress={() => {
                                            setOtherActivity(act, true)
                                            setOpenMonthlyActivities(false)
                                        }}
                                    >
                                        <Text style={styles.subtitle}>
                                            {act.title}
                                            {act.availability}
                                        </Text>
                                    </TouchableOpacity>
                                ))}
                            </View>
                        )}
                        <View style={styles.spacer1}></View>
                    </View>
                )}
                {selectedDay.monthly_activities.length > 0 && (
                    <>
                        {weeks[indexWeek].days[indexDay].monthly_activities.map((activity) => (
                            <View
                                key={activity._id}
                                style={[
                                    styles.containerRow,
                                    styles.optionSelected,
                                    { marginTop: 8, marginHorizontal: 12, justifyContent: 'space-between' },
                                ]}
                            >
                                <View style={[styles.containerRow, { flex: 9 }]}>
                                    <Text style={[styles.option, { flex: 2 }]}>{activity.title}</Text>
                                </View>
                                <View style={[styles.labelBis, { flex: 1, marginRight: 12 }]}>
                                    <Ionicons name={'calendar'} size={12} color={theme.colors.colorSecondary} style={styles.paddingRight} />
                                    <Text style={styles.frequencyBis}>{getFreqLabel(activity.frequency)}</Text>
                                </View>
                                <TouchableOpacity style={styles.marginRight} onPress={() => setOtherActivity(activity, false)}>
                                    <Ionicons name={'trash-outline'} size={24} color={theme.colors.error} />
                                </TouchableOpacity>
                            </View>
                        ))}
                    </>
                )}
            </View>
            <View style={styles.spacer3}></View>
        </View>
    )
}
